
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    /* eslint-disable indent */
import { getArtwork } from 'api/artworks';
import routes from 'constants/routes';
import { ArtworkTradeLayout } from 'layouts/ArtworkTradeLayout';
import { GetServerSideProps } from 'next';
import dynamic from 'next/dynamic';
import Head from 'next/head';
import { useRouter } from 'next/router';
import qs from 'qs';
import { ReactElement, useState } from 'react';
import { ArtworkRoyalty } from 'types';
import { LocalFiles } from 'utils/artwork-auth';
import { Artwork, Edition, mapIArtistsToArtists, mapIArtworkToEditions, } from 'utils/data';
const ArtworkAuthenticationForm = dynamic(() => import('components/forms/ArtworkAuthenticationForm').then(m => m.ArtworkAuthenticationForm), { ssr: false });
const ArtworkTradeForm = dynamic(() => import('components/forms/ArtworkTradeForm').then(m => m.ArtworkTradeForm), { ssr: false });
const ReviewTradeForm = dynamic(() => import('components/forms/ReviewTradeForm').then(m => m.ReviewTradeForm), { ssr: false });
const ShippingAndBillingForm = dynamic(() => import('components/forms/ShippingAndBillingForm').then(m => m.ShippingAndBillingForm), { ssr: false });
const StripeSetupProvider = dynamic(() => import('contexts/providers/StripeSetupProvider').then(m => m.StripeSetupProvider), { ssr: false });
type Props = {
    artwork: Artwork;
    currentEdition: Edition;
};
const SellOrAsk = ({ artwork, currentEdition }: Props) => {
    const router = useRouter();
    const [localFiles, setLocalFiles] = useState<LocalFiles>({
        artwork: [],
        coa: [],
        editionNumber: [],
        provenence: []
    });
    const isAuthPage = router.asPath.startsWith(routes.askOrSell.authentication);
    const isSubmitPage = router.asPath.startsWith(routes.askOrSell.submitDocuments);
    const isShippingAndBillingPage = router.asPath.startsWith(routes.askOrSell.shippingAndBilling);
    const isReviewSalePage = router.asPath.startsWith(routes.askOrSell.reviewSale);
    return (<>
      <Head>
        <meta name='robots' content='noindex'/>
      </Head>

      {!isAuthPage &&
            !isSubmitPage &&
            !isShippingAndBillingPage &&
            !isReviewSalePage && (<ArtworkTradeForm type='ask-or-sell' artwork={artwork} currentEdition={currentEdition}/>)}

      {(isAuthPage || isSubmitPage) && (<ArtworkAuthenticationForm artwork={artwork} currentEdition={currentEdition} localFiles={localFiles} setLocalFiles={setLocalFiles}/>)}

      {isShippingAndBillingPage && (<StripeSetupProvider>
          <ShippingAndBillingForm artwork={artwork} currentEdition={currentEdition}/>
        </StripeSetupProvider>)}

      {isReviewSalePage && (<StripeSetupProvider>
          <ReviewTradeForm artwork={artwork} currentEdition={currentEdition} localFiles={localFiles}/>
        </StripeSetupProvider>)}
    </>);
};
SellOrAsk.getLayout = (page: ReactElement<Props>) => (<ArtworkTradeLayout type='ask-or-sell' artwork={page.props.artwork} currentEdition={page.props.currentEdition}>
    {page}
  </ArtworkTradeLayout>);
const fetchData = async (id: number) => {
    const query = qs.stringify({
        populate: [
            'images',
            'images.formats',
            'editions',
            'editions.asks',
            'editions.bids',
            'editions.lowestAsk',
            'editions.highestBid',
            'editions.additionalCertification',
            'editions.includes',
            'editions.features',
            'artists',
            'artists.nationalities',
        ]
    }, {
        encodeValuesOnly: true
    });
    const artworkData = await getArtwork(id, query);
    const name = artworkData.data.attributes.name as string;
    const images = artworkData?.data?.attributes?.images?.data?.map(img => ({
        id: img.id,
        ...img.attributes
    })) || [];
    const editions = mapIArtworkToEditions(artworkData?.data) || {};
    const artists = mapIArtistsToArtists(artworkData?.data?.attributes?.artists?.data);
    const royalty = artworkData.data.attributes.royalty as ArtworkRoyalty;
    return { name, artists, editions, images, royalty };
};
const getServerSideProps: GetServerSideProps<Props> = async ({ params, }) => {
    const slug = params?.slug;
    if (!slug) {
        return { notFound: true };
    }
    const id = Number(slug[slug.length - 2]);
    if (isNaN(id)) {
        return { notFound: true };
    }
    const editionName = slug[slug.length - 1];
    if (typeof editionName !== 'string') {
        return { notFound: true };
    }
    try {
        const data = await fetchData(id);
        const currentEdition = data.editions.find(edition => edition.name === editionName);
        if (!currentEdition) {
            return { notFound: true };
        }
        return {
            props: {
                artwork: {
                    id,
                    ...data
                },
                currentEdition
            }
        };
    }
    catch (error) {
        return { notFound: true };
    }
};
export default SellOrAsk;

    async function __Next_Translate__getServerSideProps__196c3406837__(ctx) {
      const res = await getServerSideProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/ask-or-sell/[...slug]',
            loaderName: 'getServerSideProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getServerSideProps__196c3406837__ as getServerSideProps }
  